import React from 'react'
import { getClassNames } from '../../_utils/classnames'
import { INotificationBuilderState } from '../notification-builder/interfaces/notification-builder-state.interface'
import { DomainDto } from '../../dtos/domain'
import './notification-template-selector.scss'

import { Loading3QuartersOutlined } from '@ant-design/icons'
import { Select, Well } from '@pushly/aqe/lib/components'

type NotificationTemplateSelectProps = {
    className?: string
    builder: INotificationBuilderState
    domain: DomainDto
    value?: number
    disabled?: boolean
    isInDrawer?: boolean
    onChange: (change: { id?: number; domain: DomainDto; usingTemplate?: boolean }) => void
}

export const NotificationTemplateSelector = (props: NotificationTemplateSelectProps) => {
    const { className, builder, domain, value, disabled = false, isInDrawer = false, onChange } = props

    return (
        <Well
            title="Template"
            hideHeader={false}
            footerMode="hidden"
            className={`notification-template-selector ${className}`}
            variant={isInDrawer ? 'ghost' : 'default'}
        >
            <div>
                {/*<div style={{ marginBottom: '6px' }}>*/}
                {/*    <label>*/}
                {/*        <Switch*/}
                {/*            style={{ marginRight: '6px' }}*/}
                {/*            checked={builder.usingTemplate}*/}
                {/*            size="small"*/}
                {/*            aria-label="Use saved template"*/}
                {/*            onChange={() => {*/}
                {/*                onChange({ id: undefined, domain, usingTemplate: !builder.usingTemplate })*/}
                {/*            }}*/}
                {/*        />*/}
                {/*        <span>Use saved template</span>*/}
                {/*    </label>*/}
                {/*</div>*/}
                <div className={getClassNames('notif-template-selector')}>
                    <Select
                        prefix="Template:"
                        aria-label="Select notification template"
                        placeholder={
                            !builder.availableTemplates.length ? (
                                <Loading3QuartersOutlined spin={true} />
                            ) : (
                                'Select a template'
                            )
                        }
                        showSearch={false}
                        disabled={disabled}
                        allowClear={true}
                        loading={builder.loading}
                        options={builder.availableTemplates.map((t) => ({ label: t.name, value: t.id }))}
                        onChange={(val) =>
                            onChange({
                                id: val as number,
                                domain,
                                usingTemplate: !!val,
                            })
                        }
                        value={value ?? undefined}
                    />
                </div>
            </div>
        </Well>
    )
}
